import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import DataTable from '../../components/ui/data-table';
import EmptyState from '../../components/ui/empty-state.jsx';
import LoadingSpinner from '../../components/common/LoadingSpinner.jsx';
import { Users, Mail, Calendar } from 'lucide-react';

const StudentsPage = () => {
  const [students, setStudents] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const fetchStudents = async () => {
    try {
      setLoading(true);
      setError(null);
      // TODO: Replace with actual API call
      // const res = await teacherAPI.getMyStudents();
      // setStudents(res.data.data || []);
      
      // Placeholder data for now
      setStudents([]);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load students');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchStudents();
  }, []);

  const columns = [
    { id: 'name', header: 'Student Name', accessorKey: 'name', sortable: true },
    { id: 'email', header: 'Email', accessorKey: 'email' },
    { id: 'class', header: 'Class', accessorKey: 'className' },
    { id: 'attendance', header: 'Attendance %', accessorKey: 'attendancePercentage' },
    {
      id: 'actions',
      header: 'Actions',
      cell: ({ row }) => (
        <div className="flex items-center gap-2">
          <Button size="sm" variant="outline">
            <Mail className="w-4 h-4 mr-1" />
            Message
          </Button>
          <Button size="sm" variant="outline">
            View Profile
          </Button>
        </div>
      )
    }
  ];

  if (loading) return <LoadingSpinner />;
  if (error) return (
    <div className="p-6">
      <Card>
        <CardContent className="p-6">
          <p className="text-red-600 text-sm">{String(error)}</p>
          <Button className="mt-3" onClick={fetchStudents}>Retry</Button>
        </CardContent>
      </Card>
    </div>
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">My Students</h2>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm">
            <Calendar className="w-4 h-4 mr-2" />
            Attendance Report
          </Button>
          <Button variant="outline" size="sm">
            Export Data
          </Button>
        </div>
      </div>

      {(!students || students.length === 0) ? (
        <EmptyState 
          icon={Users}
          title="No students found"
          description="You don't have any students assigned to your classes yet."
          action
          actionLabel="Refresh"
          onAction={fetchStudents}
        />
      ) : (
        <Card>
          <CardContent className="p-0">
            <DataTable data={students} columns={columns} searchable />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default StudentsPage;
